
import api from './index';

export default {
  // Obtener todas las incidencias
  async getIncidents(page = 1, pageSize = 10, search='') {
    try {
      const response = await api.get('/incidents', {
        params: {
          page,
          pageSize: pageSize,
          search
        }
      });
      return response.data;
      
    } catch (error) {
      console.error('Error al obtener incidencias:', error);
      throw error;
    }
  },

  // Obtener detalles de una incidencia
  async getIncidentDetails(id: number) {
    try {
      const response = await api.get(`/incidents/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener detalles de la incidencia:', error);
      throw error;
    }
  },

  async createIncident(data: any) {
    try {
      const response = await api.post('/incidents/', data);
      return response.data;
    } catch (error) {
      console.error('Error al crear la incidencia:', error)
    }
  },

  // Actualizar una incidencia
  async updateIncident(id: number, data: any) {
    try {
      const response = await api.patch(`/incidents/${id}/`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar la incidencia:', error);
      throw error;
    }
  },

  // Buscar incidencias por término
  async searchIncidents(query: string) {
    try {
      const response = await api.get('/incidents/search', {
        params: { q: query },
      });
      return response.data;
    } catch (error) {
      console.error('Error al buscar incidencias:', error);
      throw error;
    }
  },
};